export default "__VITE_ASSET__B4O9FS70__"